import React, { Component } from "react";
import PropTypes from "prop-types";
import { NIL } from "uuid";
import { Button, Col, FormGroup, Modal, Label, Row, Input } from "reactstrap";
import { getMaxValue } from "helpers/utils";
import PhoneRow from "../../containers/deliverer/PhoneRow";
const phoneTypeOptions = [
  { key: 0, value: "Primary", label: "Primary" },
  { key: 0, value: "Alternative", label: "Alternative" },
];

export class ModalFormShippingContact extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: NIL,
      userId: null,
      contact: "",
      address: "",
      submitted: false,
      errMessage: "",
      phones: [
        { id: NIL, type: "Primary", index: 0, phoneNumber: "099780960" },
      ],
    };
  }

  onOpened = () => {
    const { contact, item, userId } = this.props;

    if (item) {
      this.setState({
        ...item,
        phones:
          item.phones && item.phones.length > 0
            ? item.phones.map((phone, index) => {
                return {
                  ...phone,
                  index,
                  type: phoneTypeOptions.find(e => e.value === phone.type),
                };
              })
            : [
                {
                  type: null,
                  phoneNumber: "",
                  index: 0,
                },
              ],
      });
    } else {
      this.setState({
        id: NIL,
        userId,
        contact,
        address: "",
        phones: [
          {
            type: null,
            phoneNumber: "",
            index: 0,
          },
        ],
        submitted: false,
      });
    }
  };

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };
  isValidPhone = phone => phone && phone.phoneNumber && phone.type;

  isValidPhones = () => {
    const { phones } = this.state;
    return phones && phones.filter(e => this.isValidPhone(e));
  };

  handleSubmit = () => {
    const { id, userId, contact, phones, address } = this.state;
    this.setState({
      submitted: true,
    });

    if (contact && phones && address) {
      const shippingAddress = {
        id,
        userId,
        contact,
        phones:
          phones &&
          phones
            .filter(p => this.isValidPhone(p))
            .map(phone => {
              return {
                id: phone.id,
                type: phone.type?.value ?? null,
                phoneNumber: phone.phoneNumber,
              };
            }),
        address,
      };

      this.props.onSubmit(shippingAddress);
    }
  };

  handleOnAdd = () => {
    const { phones } = this.state;

    let max = 0;

    if (phones.length > 0) {
      max = getMaxValue(
        phones.map(a => {
          return a.index;
        })
      );
      max += 1;
    } else {
      max = max + 1;
    }

    const newPhone = {
      index: max,
      type: null,
      phoneNumber: "",
    };

    this.setState(prevState => ({
      phones: prevState.phones.concat(newPhone),
    }));
  };

  handleOnRemove = phone => {
    const { phones } = this.state;

    this.setState({
      phones: phones.filter(e => e.index !== phone.index),
    });
  };

  handleOnChange = phone => {
    this.setState(prevState => ({
      phones: prevState.phones.map(a => {
        return a.index === phone.index ? phone : a;
      }),
    }));
  };

  render() {
    const { isOpen, toggle, title } = this.props;
    const { submitted, errMessage, phones } = this.state;
    return (
      <Modal
        size="md"
        onOpened={this.onOpened}
        isOpen={isOpen}
        toggle={toggle}
        backdrop="static"
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            {title}
          </h5>
          <button
            type="button"
            onClick={toggle}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div className="modal-body">
          <Row>
            <Col md={12}>
              <FormGroup className="mb-3">
                <Label htmlFor="validationCustom01">Receiver</Label>
                <Input
                  type="text"
                  name="contact"
                  placeholder="Receiver"
                  className={
                    submitted && !this.state.contact ? "is-invalid" : ""
                  }
                  value={this.state.contact}
                  onChange={this.handleChange}
                />
                {submitted && !this.state.contact && (
                  <div className="invalid-feedback-custom">
                    Receiver is required.
                  </div>
                )}
              </FormGroup>
              <FormGroup>
                <Label htmlFor="">Phones</Label>
                <div
                  className={
                    this.isValidPhones().length > 0 ? "" : "is-invalid"
                  }
                >
                  {phones.map((phone, index) => {
                    return (
                      <PhoneRow
                        phone={phone}
                        key={index}
                        isPrimary={index === 0}
                        onAdd={this.handleOnAdd}
                        onRemove={this.handleOnRemove}
                        onChange={this.handleOnChange}
                      />
                    );
                  })}
                </div>
                {submitted && !this.isValidPhones().length > 0 && (
                  <div className="invalid-feedback-custom">
                    Phone is invalid
                  </div>
                )}
              </FormGroup>

              <FormGroup className="mb-3">
                <Label htmlFor="validationCustom01">Address</Label>
                <Input
                  type="textarea"
                  name="address"
                  placeholder="Address"
                  rows={3}
                  className={
                    submitted && !this.state.address ? "is-invalid" : ""
                  }
                  value={this.state.address}
                  onChange={this.handleChange}
                />
                {submitted && !this.state.address && (
                  <div className="invalid-feedback-custom">
                    Address is required.
                  </div>
                )}
              </FormGroup>
            </Col>
          </Row>
        </div>
        <div className="modal-footer">
          <Button color="primary" onClick={this.handleSubmit} type="submit">
            Submit
          </Button>
          <button
            type="button"
            onClick={toggle}
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            Close
          </button>
        </div>
      </Modal>
    );
  }
}

ModalFormShippingContact.propTypes = {
  item: PropTypes.object,
  title: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func,
  onSubmit: PropTypes.func,
  userId: PropTypes.string,
  id: PropTypes.string,
  contact: PropTypes.string,
};

export default ModalFormShippingContact;
